'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _certificates = require('./certificates.component');

var _certificates2 = _interopRequireDefault(_certificates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var certificatesModule = _angular2.default.module('app.containers.certificates', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('certificates', {
    url: '/certificates',
    template: '<certificates></certificates>'
  });
}).component('certificates', _certificates2.default);

exports.default = certificatesModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/certificates/certificates.js
 **/